<h2 mat-dialog-title>{{data.title}}</h2>
    <mat-dialog-content>
        <p class="mat-body-1">{{data.message}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button [mat-dialog-close]="false">Abbrechen</button>
        <button mat-raised-button [mat-dialog-close]="true" color="primary">Bestätigen</button>
    </mat-dialog-actions>